import { render, staticRenderFns } from "./right_finn.vue?vue&type=template&id=082dc22b&scoped=true&"
import script from "./right_finn.vue?vue&type=script&lang=js&"
export * from "./right_finn.vue?vue&type=script&lang=js&"
import style0 from "./right_finn.vue?vue&type=style&index=0&id=082dc22b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082dc22b",
  null
  
)

export default component.exports